import NihaoBridgePage from "../components/pages/nihao-bridge/NihaoBridgePage";

export default function NihaoBridgeThPage() {
  return <NihaoBridgePage locale="th" />;
}
